<template>
  <div style="line-height: 1.5">
    <div>
      <strong>设备名称：</strong> <i>{{ alarmData.deviceName || alarmData.deviceId || '未知' }}</i>
    </div>
    <div>
      <strong>通道名称：</strong> <i>{{ alarmData.channelName || alarmData.channelId || '未知' }}</i>
    </div>
    <div v-if="alarmData.deviceRemark">
      <strong>设备备注：</strong> <i>{{ alarmData.deviceRemark }}</i>
    </div>
    <div>
      <strong>报警级别：</strong> <i>{{ alarmData.alarmPriorityDescription || '未知' }}</i>
    </div>
    <div>
      <strong>报警方式：</strong> <i>{{ alarmData.alarmMethodDescription || '未知' }}</i>
    </div>
    <div>
      <strong>报警类型：</strong> <i>{{ alarmData.alarmTypeDescription || '未知' }}</i>
    </div>
    <div>
      <strong>报警内容：</strong> <i>{{ alarmData.alarmDescription || '未知' }}</i>
    </div>    
    <div>
      <strong>报警时间：</strong> <i>{{ alarmData.alarmTime || '未知' }}</i>
    </div>
    <el-button 
      type="primary"
      size="small"
      style="margin-top: 8px;"
      @click="playVideo"
      :loading="loading">
      实时视频
    </el-button>
  </div>
</template>

<script>
// 使用全局注册的事件总线

export default {
  name: 'AlarmNotification',
  props: {
    alarmData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    playVideo(event) {
      // 阻止事件冒泡
      if (event) event.stopPropagation();
      // 使用事件总线触发播放视频事件
      if (this.alarmData.deviceId && this.alarmData.channelId) {
        this.playChannelVideo(this.alarmData.deviceId, this.alarmData.channelId);
      }
    },
    playChannelVideo(deviceId, channelId) {
      if (deviceId && channelId) {
        // 设置加载状态为true
        this.loading = true;
        // 通知设备上传媒体流并播放视频
        this.$axios({
          method: 'get',
          url: '/api/play/start/' + deviceId + '/' + channelId,
          params: {
            isSubStream: false
          }
        }).then((res) => {
          if (res.data.code === 0) {
            // 使用事件总线触发播放视频事件，将流信息传递给App.vue中的devicePlayer组件
            this.$eventBus.$emit('playChannelVideo', deviceId, channelId, {
              streamInfo: res.data.data,
              hasAudio: true
            });
          } else {
            this.$message.error(res.data.msg);
          }
          // 无论成功或失败，都设置加载状态为false
          this.loading = false;
        }).catch((error) => {
          console.error(error);
          this.$message.error("请求视频流失败");
          // 请求失败时，也设置加载状态为false
          this.loading = false;
        });
      }
    }
  }
}
</script>

<style scoped>
.el-button--small {
  padding: 5px 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/alarm/AlarmNotification.vue